
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class EditLengthDependentProductionProcessModal extends Vue {

    @Prop() allProductionProcesses: OM.ProductionProcessListVM[];
    @Prop() estimationIdentifier: string;
    @Prop() modelToEdit: OM.FabricProductionProcess;
    @Prop() saveCallback: (layer: OM.EditEstimationLayerProductionProcessVM) => void;

    model = new OM.EditEstimationLayerProductionProcessVM();

    created() {        
        this.model.identifier = this.estimationIdentifier;

        if(this.modelToEdit) {
            this.model.productionProcessIdentifier = this.allProductionProcesses.find(x => x.name == this.modelToEdit.name).identifier;
            this.model.units = this.modelToEdit.units;
            this.model.width = this.modelToEdit.width;
            this.model.thickness = this.modelToEdit.thickness;
            this.model.density = this.modelToEdit.density;
            this.model.length = this.modelToEdit.length;
            this.model.productionCountry = this.modelToEdit.productionCountry.identifier;
        }
    }

    get disabled(){
        return !this.model.productionProcessIdentifier || !this.model.width || !this.model.thickness || !this.model.density || !this.model.length;
    }

    save() {
        this.saveCallback(this.model);
    }
}
